(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__form').forEach(function(form) {
    /* Anti-spam: genera token e timestamp al caricamento */
    var ts = Date.now();
    var tsField = form.querySelector('.contact-form__ts');
    var tokenField = form.querySelector('.contact-form__token');
    if (tsField) tsField.value = String(ts);
    if (tokenField) {
      /* Token = hash semplice basato su timestamp + user agent, verificabile lato JS */
      var raw = 's776_' + ts + '_' + navigator.userAgent.length;
      var hash = 0;
      for (var i = 0; i < raw.length; i++) {
        hash = ((hash << 5) - hash) + raw.charCodeAt(i);
        hash |= 0;
      }
      tokenField.value = 'v1_' + Math.abs(hash).toString(36);
    }

    form.addEventListener('submit', function(e) {
      /* 1. Honeypot check */
      var hp = form.querySelector('[name="contact[website]"]');
      if (hp && hp.value.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      /* 2. Token check — deve esistere e iniziare con v1_ */
      var token = form.querySelector('.contact-form__token');
      if (!token || !token.value || token.value.indexOf('v1_') !== 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      /* 3. Timing check — almeno 3 secondi dal caricamento */
      var loadTime = parseInt(form.querySelector('.contact-form__ts').value, 10);
      if (Date.now() - loadTime < 3000) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
